/** Motivos para "Reportar" una respuesta del asesor o un reporte (van a review_queue.reason). */
export const MOTIVOS = ["Número incorrecto", "Recomendó un instrumento", "Tono", "No entendió mi pregunta", "Otro"] as const;
export const motivoClave = (m: string) => m.toLowerCase().replace(/ /g, "_");
